import { IModelEntity } from '@pit/core';
import { IDtoResourceType } from './dto.resource.type.interface';

export interface IDtoResourceFaultPenalty extends IModelEntity {

    penalty?: number;

    resourceType?: IDtoResourceType;

}
